import React from 'react';
import config from '../../config';
import * as commonActions from '../../actions/commonActions';

const ConflictRow = ({ c, courses, onDelete, handleEdit }) => {
  return (
    <div>
      {courses.length > 0 ? (
        <div className="conflict-row">
          <div className="conflict-name">
            <div className="name">
              <span
                onClick={() => {
                  handleEdit(c);
                }}
              >
                {c.name && c.name.length > 40 ? c.name.substr(0, 39) + '...' : c.name}
              </span>
            </div>
            <div className="conflict-kind">
              Kind: <span>{c.kind == 1 ? 'Number' : 'Weight'}</span>
            </div>
            {' | '}
            <div className="conflict-limit">
              Limit: <span>{c.limit}</span>
            </div>
          </div>
          <div className="conflict-courses">
            {c.courses.map(course => {
              return (
                <div key={course} className="conflict-course">
                  {commonActions.getCourseName(course, courses)}
                </div>
              );
            })}
          </div>
          <div className="icon-delete">
            <i
              onClick={() => {
                onDelete(c.id, config.conflicts);
              }}
              className="fa fa-trash-o"
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ConflictRow;



// WEBPACK FOOTER //
// ./src/components/runs/ConflictRow.js